import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavCollapseService } from '../../_services/nav-collapse.service';

@Component({
  selector: 'app-main-app',
  templateUrl: './main-app.component.html',
  styleUrls: ['./main-app.component.css']
})
export class MainAppComponent implements OnInit, OnDestroy {
  isMinimized: boolean = false;
  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(private navCollapseService: NavCollapseService) {
    this.navCollapseService.isMinimized$.pipe(takeUntil(this.onDestroy$)).subscribe(
      value => { this.isMinimized = value });
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
